import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import SelectYourPlan from "../../../assets/images/PaymentIcons/SelectPlans.svg";
import ListArrow from "../../../assets/images/PaymentIcons/ListBackArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo, clearUserInfo } from "../../../store/auth/authSlice";
import { Modal, SessionExpired } from "../../../../src/components/common";
import { useGetUserQuery } from "../../../store/auth/usersApiSlice";
import GetTheComapnyBoywithpinacular from "../../../assets/images/boywithpinacular.png";
import { ReactComponent as Spinner } from "../../../assets/icons/spinner.svg";


export const PaymentPlans = () => {
  const location = useLocation();
  const { company_id } = location.state || {};
  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [forUpgradePlan, setForUpgradePlan] = useState(false);
  const [fromfooter, setfromFooter] = useState(false);
  const [isGetTheCompanyOpen, setisGetTheCompanyOpen] = useState(false);
  const { token } = useSelector((state) => state.auth);
  const [isSessionExpired, setSessionExpired] = useState(false);
  const dispatch = useDispatch();
  const { data, isSuccess, isError, error } = useGetUserQuery(token);
  useEffect(() => {
    if (isError) {
      if (error?.data?.code == 'token_not_valid') {
        setSessionExpired(true);
      }
    }
  }, [data, dispatch, isSuccess, isError]);

  const plansUpgradeInformation = [
    {
      title: "Basic",
      mode: "subscription",
      slug: "basic",
      subsCharge: 195,
      talkToSales: true,
      Features: [
        "3 profile views for 1 month",
        "full profile access for 1 month,",
      ],
    },
    {
      subsType: "Recommended",
      title: "Pro",
      slug: "pro",
      mode: "subscription",
      subsCharge: 275,
      talkToSales: true,
      Features: [
        "5 profile views per month",
        "full profile access for 1 month",
      ],
    },
    {
      title: "Premium",
      mode: "subscription",
      slug: "premium",
      subsCharge: 500,
      talkToSales: true,
      Features: [
        "10 profile views per month",
        "full profile access for 1 month",
      ],
    },
  ];

  const plansInformation = [
    {
      title: "Pay-as-you-go",
      mode: "one-time",
      slug: "pay-as-you-go",
      subsCharge: 79,
      talkToSales: true,
      Features: [
        "1 profile views for 1 month",
        "full profile access for 1 month.",
      ],
    },
    {
      title: "Basic",
      mode: "subscription",
      slug: "basic",
      subsCharge: 195,
      talkToSales: true,
      Features: [
        "3 profile views for 1 month",
        "full profile access for 1 month",
      ],
    },
    {
      subsType: "Recommended",
      title: "Pro",
      slug: "pro",
      mode: "subscription",
      subsCharge: 275,
      talkToSales: true,
      Features: [
        "5 profile views per month",
        "full profile access for 1 month",
      ],
    },
    {
      title: "Premium",
      mode: "subscription",
      slug: "premium",
      subsCharge: 500,
      talkToSales: true,
      Features: [
        "10 profile views per month",
        "full profile access for 1 month",
      ],
    },
  ];

  useEffect(() => {


    // we are maintaing a key "selectedPlan" when we are redirecting user to search page, this is for tha case when user directly clicked on the plan page and desided to go with pay-as-you-go
    // we will need to se this key when we are transfering user to search page
    const selectedPlanString = sessionStorage.getItem("selectedPlan");

    if (selectedPlanString) {
      // Parse the JSON string to get the plan object
      const selectedPlan = JSON.parse(selectedPlanString);

      // Clear the value of "selectedPlan" from session storage we are doing this because ones user is redirected we don't need that veriable if user decide to cancle payment and do something diffrent this also applicable in case of failed payment
      sessionStorage.removeItem("selectedPlan");

      // Call the navigatetoBilling function with the selected plan
      navigatetoBilling(selectedPlan);
    }

    if (localStorage.getItem("fromFooter")) {
      setfromFooter(true);
    }
    if (localStorage.getItem("UpgradePlan")) {
      setForUpgradePlan(true);
    }
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 640);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handlePageChange = (index) => {
    setCurrentPage(index);
  };
  
  const navigatetoBilling = (plan) => {
    if (fromfooter) {
      localStorage.removeItem("fromfooter");
      if (plan.slug != 'pay-as-you-go') {
        localStorage.setItem("UpgradePlan", true);
        if (token != undefined && !isError) {
          navigate("/plans/paymentdetails", {
            state: {
              planDetails: plan,
              company_id: company_id,
            },
          });
        } else {
          localStorage.setItem("lastVisited", `/plans`);
          localStorage.setItem("slug", plan.slug);
          navigate("/login")
        }
      } else {
        setisGetTheCompanyOpen(true);
      }
    } else {
      if (token != undefined && !isError) {
        navigate("/plans/paymentdetails", {
          state: {
            planDetails: plan,
            company_id: company_id,
          },
        });
      } else {
        localStorage.setItem("lastVisited", `/plans`);
        localStorage.setItem("slug", plan.slug);
        navigate("/login")
      }
    }
  }

  useEffect(()=>{
    const plan = {
      title: "Pay-as-you-go",
      mode: "one-time",
      slug: "pay-as-you-go",
      subsCharge: 79,
      talkToSales: true,
      Features: [
        "1 profile views for 1 month",
        "full profile access for 1 month.",
      ],
    };
    navigatetoBilling(plan)
  },[])
  const handleGetCompanyPopup = () => {
    setisGetTheCompanyOpen(!isGetTheCompanyOpen);
  };

  const handleSearchProfile = () => {
    // Find the selected plan
    const selectedPlan = plansInformation.find((plan) => plan.slug === "pay-as-you-go");

    // Set the selected plan to session storage
    if (selectedPlan) {
      sessionStorage.setItem("selectedPlan", JSON.stringify(selectedPlan));
    }
    
    // Navigate to the search page
    setisGetTheCompanyOpen(false);
    navigate("/search");
  };

  return (
    <>
      <div>
        <div className="text-left">
          <div className="flex justify-between px-2">
            <div className="my-8">
              <h2 className="text-f20 md:text-f24 font-bold">
                Explore Plans
              </h2>
              <p className="text-secondary text-f16">
                Discover a variety of options tailored to your needs, offering
                everything from a single profile view to multiple views across
                different subscriptions.
              </p>
            </div>
            <div className="hidden sm:block">
              <img src={SelectYourPlan} alt="planImages" />
            </div>
          </div>
        </div>
        {isGetTheCompanyOpen && (
          <Modal modalHandle={handleGetCompanyPopup}>
            <div className="text-center flex flex-col items-center">
              <img src={GetTheComapnyBoywithpinacular} style={{ width: '100px', padding: '10px' }} alt="GetTheCompany" />

              <h3 className="text-secondarytwo text-left text-f20 font-semibold">
                Pay as you go
              </h3>
              <p className="text-secondary pt-2 pb-4 w-80 text-f14">Search for a company profile and do payment</p>
              <hr />
              <button
                onClick={handleSearchProfile}
                className="bg-primary px-4 py-2 text-white text-f14 rounded w-full"
              >
                Search Profile
              </button>
              <div className="flex justify-between text-secondary pt-4 items-center"></div>
            </div>
          </Modal>
        )
        }
        {plansUpgradeInformation.length <= 0 && plansInformation.length <= 0 &&
          <div className="spinnerwheel bg-white">
            <div><Spinner /></div>
            <p>Loading Plans</p>
          </div>
        }

        {isSmallScreen ? (
          <Carousel
            showThumbs={true}
            showStatus={false}
            thumbWidth={4}
            selectedItem={currentPage}
            onChange={handlePageChange}
            renderIndicator={(onClickHandler, isSelected, index, label) => {
              const defStyle = {
                marginLeft: 20,
                marginBottom: 10,
                cursor: "pointer",
                width: "8px", // Define equal width and height for a circle
                height: "8px", // Define equal width and height for a circle
                borderRadius: "50%",
                display: "inline-block" // Ensure it's a circle
              };
            
              const style = isSelected
                ? { ...defStyle, backgroundColor: "#FB512D", border: "none" } // Active state style
                : { ...defStyle, backgroundColor: "transparent", border: "1px solid #9FA4A4" }; // Inactive state style
            
              return (
                <span
                  style={style}
                  onClick={onClickHandler}
                  onKeyDown={onClickHandler}
                  value={index}
                  key={index}
                  role="button"
                  tabIndex={0}
                  aria-label={`${label} ${index + 1}`}
                />
              );
            }}
          >
            {forUpgradePlan
              ? plansUpgradeInformation.map((plan) => {
                return (
                  <div className="bg-white m-4 rounded flex flex-col gap-2 p-3">
                    <li className="mx-4 mt-4 md:m-4 rounded-lg border border-gray-300  pb-8">
                      <div className="h-[50px]">
                        {plan.subsType && (
                          <p className="bg-[#FC7457] animate-pulse  text-center text-white rounded-sm md:rounded-md py-2 ">
                            {plan.subsType}
                          </p>
                        )}
                      </div>
                      <div className="px-3 ml-2 justify-center">
                        <h2 className="font-semibold  pt-4 text-f18 md:text-f24">
                          {plan.title}
                        </h2>
                        <div className="pb-4 gap-2">
                          <div className="text-f32 md:text-f40 font-bold">
                            ${plan.subsCharge}
                          </div>
                        </div>
                      </div>
                      <div className="relative h-[80px]">
                        <div className="py-4 px-4 w-full absolute bottom-0">
                          <div className="w-full py-2">
                            <button
                              className="w-full bg-[#FB512D] py-2 md:py-3 rounded-lg text-[#EBF0F3]"
                              onClick={() => {
                                navigatetoBilling(plan)
                              }}
                            >
                              Get Started
                            </button>
                          </div>

                        </div>
                      </div>

                      <div className="px-2 md:px-4 pb-2 md:pb-4">
                        <hr></hr>
                        <div className="py-4 ">
                          <h3 className="text-f18 md:text-f24 font-semibold text-left">
                            Features
                          </h3>
                          <p className="text-f16 text-secondary text-left">
                            Everything we offer...
                          </p>
                        </div>
                        <ul>
                          {plan.Features.map((feature, index) => (
                            <li
                              key={index}
                              className="py-2 flex align-top gap-2"
                            >
                              <div className="w-5">
                                <img src={ListArrow} alt="Listarrow" />
                              </div>
                              <h4 className="text-left">{feature}</h4>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </li>
                  </div>
                );
              })
              : plansInformation.map((plan) => {
                return (
                  <div className="bg-white m-4 rounded flex flex-col gap-2 p-3">
                    <li className="m-4  rounded-lg border border-gray-300  pb-8">
                      <div className="h-[50px]">
                        {plan.subsType && (
                          <p className="bg-[#FC7457] animate-pulse  text-center text-white rounded-sm md:rounded-md py-2 ">
                            {plan.subsType}
                          </p>
                        )}
                      </div>
                      <div className="px-3 ml-2 justify-center">
                        <h2 className="font-semibold  pt-4 text-f18 md:text-f24">
                          {plan.title}
                        </h2>
                        <div className="pb-4 gap-2">
                          <div className="text-f32 md:text-f40 font-bold">
                            ${plan.subsCharge}
                          </div>
                        </div>
                      </div>
                      <div className="relative h-[80px]">
                        <div className="py-4 px-4 w-full absolute bottom-0">
                          <div className="w-full py-2">
                            <button
                              className="w-full bg-[#FB512D] py-2 md:py-3 rounded-lg text-[#EBF0F3]"
                              onClick={() => {
                                navigatetoBilling(plan)
                              }}
                            >
                              Get Started
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="px-2 md:px-4 pb-2 md:pb-4">
                        <hr></hr>
                        <div className="py-4 ">
                          <h3 className="text-f18 md:text-f24 font-semibold text-left">
                            Features
                          </h3>
                          <p className="text-f16 text-secondary text-left">
                            Everything we offer...
                          </p>
                        </div>
                        <ul>
                          {plan.Features.map((feature, index) => (
                            <li
                              key={index}
                              className="py-2 flex align-top gap-2"
                            >
                              <div className="w-5">
                                <img src={ListArrow} alt="Listarrow" />
                              </div>
                              <h4 className="text-left">{feature}</h4>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </li>
                  </div>
                );
              })}
          </Carousel>
        ) : forUpgradePlan ? (
          <div className="bg-white rounded-sm md:rounded-md mb-6 mx-2 sm:mx-0 py-2 sm:py-4">
            <ul className="sm:grid sm:grid-cols-3 my-6">
              {plansUpgradeInformation.map((plan) => {
                return (
                  <div className="bg-white m-4 rounded flex flex-col gap-2">
                    <li className="m-4  rounded-lg border border-gray-300  pb-8">
                      <div className="h-[50px]">
                        {plan.subsType && (
                          <p className="bg-[#FC7457] animate-pulse  text-center text-white rounded-sm md:rounded-md py-2 ">
                            {plan.subsType}
                          </p>
                        )}
                      </div>
                      <div className="px-3 ml-2 justify-center">
                        <h2 className="font-semibold  pt-4 text-f18 md:text-f24">
                          {plan.title}
                        </h2>
                        <div className="pb-4 gap-2">
                          <div className="text-f32 md:text-f40 font-bold">
                            ${plan.subsCharge}
                          </div>
                        </div>
                      </div>
                      <div className="relative h-[80px]">
                        <div className="py-4 px-4 w-full absolute bottom-0">
                          <div className="w-full py-2">
                            <button
                              className="w-full bg-[#FB512D] py-2 md:py-3 rounded-lg text-[#EBF0F3]"
                              onClick={() => {
                                navigatetoBilling(plan)
                              }}
                            >
                              Get Started
                            </button>
                          </div>

                        </div>
                      </div>

                      <div className="px-2 md:px-4 pb-2 md:pb-4">
                        <hr></hr>
                        <div className="py-4 ">
                          <h3 className="text-f18 md:text-f24 font-semibold text-left">
                            Features
                          </h3>
                          <p className="text-f16 text-secondary text-left">
                            Everything we offer...
                          </p>
                        </div>
                        <ul>
                          {plan.Features.map((feature, index) => (
                            <li
                              key={index}
                              className="py-2 flex align-top gap-2"
                            >
                              <div className="w-5">
                                <img src={ListArrow} alt="Listarrow" />
                              </div>
                              <h4 className="text-left">{feature}</h4>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </li>
                  </div>
                );
              })}
            </ul>
          </div>
        ) : (
          <div className="bg-white rounded-sm md:rounded-md mb-6 mx-2 sm:mx-0 py-2 sm:py-4">
            <ul className="sm:grid sm:grid-cols-4 my-6">
              {plansInformation.map((plan) => {
                return (
                  <li className="m-4 rounded-lg border border-gray-300">
                    <div className="h-[50px]">
                      {plan.subsType && (
                        <p className="bg-[#FC7457] animate-pulse  text-center text-white rounded-sm md:rounded-md py-2 ">
                          {plan.subsType}
                        </p>
                      )}
                    </div>
                    <div className="px-2">
                      <h2 className="font-semibold pt-3 text-f18 md:text-f24">
                        {plan.title}
                      </h2>
                      <div className="pb-4 gap-2">
                        <div className="text-f32 md:text-f40 font-bold">
                          ${plan.subsCharge}
                        </div>
                      </div>
                      {plan.slug === "pay-as-you-go" ? (
                        <div className="pb-4 gap-2">
                          <div className="text-f12 md:text-f12 font-light">
                            per profile
                          </div>
                        </div>
                      ) : (
                        <div className="pb-4 gap-2">
                          <div className="text-f12 md:text-f12 font-light">
                            per month
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="relative h-[80px]">
                      <div className="py-4 px-4 w-full absolute bottom-0">
                        <div className="w-full py-2">
                          <button
                            className="w-full bg-[#FB512D] py-2 md:py-3 rounded-lg text-[#EBF0F3]"
                            onClick={() => {
                              navigatetoBilling(plan)
                            }}
                          >
                            Get Started
                          </button>
                        </div>

                      </div>
                    </div>

                    <div className="px-2 md:px-4 pb-2 md:pb-4 text-start">
                      <hr></hr>
                      <div className="py-4">
                        <h3 className="text-f18 md:text-f24 font-semibold">
                          Features
                        </h3>
                        <p className="text-f16 text-secondary">
                          Everything we offer...
                        </p>
                      </div>
                      <ul>
                        {plan.Features.map((feature, index) => (
                          <li key={index} className="py-2 flex align-top gap-2">
                            <img
                              src={ListArrow}
                              className="mb-auto"
                              alt="Listarrow"
                            />
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};
